<template>
  <div class="w-100 m-auto shipments-list">
    <EasyDataTable
      ref="dataTable"
      table-class-name="vue3-easy-data-table table-shadow no-overflow"
      :headers="headers"
      :items="shipments"
      :fixed-header="false"
      no-hover
      alternating
      hide-footer
    >
      <template #loading>
        <b-spinner class="mt-5" variant="success" />
      </template>
      <template #no-data> - </template>
      <template #item="{ column, item }: { column: string; item: Shipment }">
        <span v-if="column === 'user'">
          {{ item.company.name ? item.company.name : item.company.contactName + ' ' + item.company.contactLastName }}
        </span>
        <span v-if="column === 'recipient'">
          <RecipientCell :shipment="item" />
        </span>
        <span v-if="column === 'shipmentNumber'">
          <ShipmentNumberCell :shipment="item" :display-announcement-status="true" />
        </span>
        <span v-if="column === 'lastTrackingEventStatus'">
          <TrackingStatusCell :shipment="item" />
        </span>
        <div v-if="column === 'description'" class="mw-300">
          {{ item.description }}
        </div>
        <span v-if="column === 'carrierHandle'">
          <CarrierData :shipment="item" :only-icon="!!item.adjustedCarrierHandle" />
        </span>
        <span v-if="column === 'action'">
          <button v-if="getIndex(item) === 1" class="btn btn-green">Receive (click "Enter")</button>
          <button v-else class="btn btn-green">Receive</button>
        </span>
      </template>
    </EasyDataTable>
  </div>
</template>

<script lang="ts">
import type { Shipment } from '@/types/Models/Shipment'
import { BSpinner } from 'bootstrap-vue-next'
import { ref, defineComponent } from 'vue'
import EasyDataTable, { type Header } from 'vue3-easy-data-table'
import CarrierData from '@/views/Components/Carrier/CarrierData.vue'
import RecipientCell from '@/views/Components/Shipments/Cells/Recipient.vue'
import ShipmentNumberCell from '@/views/Components/Elements/Table/ShipmentNumber.vue'
import TrackingStatusCell from '@/views/Components/Elements/Table/TrackingStatus.vue'

export default defineComponent({
  name: 'ShipmentsScan',
  components: {
    BSpinner,
    CarrierData,
    TrackingStatusCell,
    ShipmentNumberCell,
    RecipientCell,
    EasyDataTable,
  },
  props: {
    shipments: {
      type: Array as () => Shipment[],
      required: true,
    },
  },
  setup(props) {
    const dataTable = ref()
    const headers: Header[] = [
      { text: 'Shipment number', value: 'shipmentNumber' },
      { text: 'Recipient', value: 'recipient' },
      { text: 'Customer', value: 'user' },
      { text: 'Description', value: 'description' },
      { text: 'Carrier', value: 'carrierHandle' },
      { text: 'Status', value: 'lastTrackingEventStatus' },
      { text: '', value: 'action' },
    ]
    const getIndex = (item: Shipment) => props.shipments.findIndex((shipment: Shipment) => shipment.id === item.id) + 1

    return {
      dataTable,
      headers,
      getIndex,
    }
  },
})
</script>
